/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --gap: var(--nve-ref-space-lg);
}

[internal-host] {
  position: relative;
  display: flex;
  flex-direction: row;
  gap: var(--gap);
}

:host([vertical]) [internal-host] {
  flex-direction: column;
}

:host(:not([vertical])) ::slotted(nve-steps-item:not(:last-child))::after {
  content: '';
  position: absolute;
  width: var(--gap);
  top: 50%;
  border: var(--nve-ref-border-width-sm) dashed var(--nve-ref-border-color);
}

:host([vertical]) ::slotted(nve-steps-item:not(:last-child))::after {
  content: '';
  position: absolute;
  height: var(--gap);
  left: var(--nve-ref-size-500);
  top: 100%;
  border: var(--nve-ref-border-width-sm) dashed var(--nve-ref-border-color);
}

:host([vertical]:not([container='condensed'])) ::slotted(nve-steps-item) {
  --width: 100%;
}
